var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgU23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 4,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#292929",
    strokeWidth: 3,
    fill: "#FFFFFF",
    cx: 30,
    cy: 30,
    r: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0123371,6.92612035 C42.2970197,6.48075592 43.9819222,7.16980573 46.0122809,8.4612853 C52.874901,12.8264912 55.1805003,18.6611893 55.1805003,19.63803 C55.1986713,20.0723864 55.04402,20.3864083 54.8106617,20.6791618 C54.3743073,21.226579 53.6950395,21.6976668 52.887615,22.1597716 C48.9832285,24.2896774 48.3531966,29.8214332 48.0903715,34.8865484 C47.9922857,36.7768373 47.919749,38.5357002 47.5500954,39.8090664 C47.426957,40.2332482 47.3309453,40.6722386 46.9985599,40.8348261 C46.4022681,40.9777708 45.8862159,40.9818617 45.4409153,40.8286244 C44.9443463,40.6577446 44.5575261,40.2986606 44.2275049,39.846389 C43.0128373,38.181769 42.5254406,35.3999599 42.1540326,32.7395101 L42.1540326,32.7395101 L42.0824388,32.2135702 C42.0021389,31.6093419 41.9289499,31.0123794 41.8580546,30.4343199 C41.5355522,27.8047286 41.1894817,25.5556714 40.5969634,24.504213 C38.4705983,20.963599 37.4404437,17.7145118 37.5701459,14.7034638 C37.6919162,11.8765556 38.8562388,9.29070076 41.0123371,6.92612035 Z",
    id: "\\u8DEF\\u5F84-160",
    stroke: "#292929",
    strokeWidth: 3,
    fill: "#2567F7",
    transform: "translate(46.371351, 23.878896) rotate(4.000000) translate(-46.371351, -23.878896) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2176938,52.3453754 C9.83957866,48.4295408 13.7248868,37.4091655 18.3764234,37.5952604 C20.1810856,37.9245379 20.8218558,38.9994234 20.8218558,45.0782759 C20.7836912,47.8591025 21.6580953,49.2348399 24.447617,49.7215674 C28.7071985,50.4689294 29.5152544,57.2238985 26.6433756,57.748046 C24.7627677,57.9392091 17.3883004,55.9686981 14.2176938,52.3453754 Z",
    id: "\\u8DEF\\u5F84-161",
    fill: "#2567F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3491784,50.202975 C10.3904471,44.1888435 13.7175846,37.4517382 17.3049948,37.5952604 C19.1096571,37.9245379 19.7504272,38.9994234 19.7504272,45.0782759 C19.7122626,47.8591025 20.5866667,49.2348399 23.3761884,49.7215674 C27.6357699,50.4689294 28.4438258,57.2238985 25.571947,57.748046",
    id: "\\u8DEF\\u5F84-161",
    stroke: "#292929",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#292929",
    strokeWidth: 3,
    cx: 30,
    cy: 30,
    r: 28.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(2.888199, 5.962733)",
    fillRule: "nonzero",
    stroke: "#292929",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.112637,-1.5 C13.3140299,-1.5 16.2175745,-0.198188067 18.3205183,1.90475571 C20.4234621,4.00769949 21.725274,6.91124412 21.725274,10.112637 C21.725274,13.8402099 19.5584127,16.7902741 17.0909833,19.3896101 C16.5827854,19.9248002 15.7665905,20.7515959 14.8750236,21.6449875 L14.2720322,22.2479786 C13.155437,23.3624964 12.0034714,24.5018022 11.2408595,25.2550762 C10.9701472,25.5224737 10.6501898,25.8383311 10.2995738,26.1838423 C9.90165768,25.8850195 9.53683138,25.6000456 9.22390404,25.3380858 C8.27216811,24.5413624 7.02641139,23.3095091 5.83355081,22.1180714 L5.83355081,22.1180714 L5.20865218,21.4930008 C4.38402185,20.6668049 3.63220231,19.9076128 3.13513926,19.3931075 C0.787193157,16.9571458 -1.5,13.9216216 -1.5,10.112637 C-1.5,6.91124412 -0.198188067,4.00769949 1.90475571,1.90475571 C4.00769949,-0.198188067 6.91124412,-1.5 10.112637,-1.5 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2484472,5.67391304 C11.5106028,5.67391304 12.6544315,6.18613915 13.4825934,7.01430101 C14.3107553,7.84246286 14.8229814,8.98629164 14.8229814,10.2484472 C14.8229814,11.5106028 14.3107553,12.6544315 13.4825934,13.4825934 C12.6544315,14.3107553 11.5106028,14.8229814 10.2484472,14.8229814 C8.98629164,14.8229814 7.84246286,14.3107553 7.01430101,13.4825934 C6.18613915,12.6544315 5.67391304,11.5106028 5.67391304,10.2484472 C5.67391304,8.98629164 6.18613915,7.84246286 7.01430101,7.01430101 C7.84246286,6.18613915 8.98629164,5.67391304 10.2484472,5.67391304 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#2567F7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgU23);
export default __webpack_public_path__ + "static/media/u23.0d0d94463485ddbe4cc92cd1d1385c2a.svg";
export { ForwardRef as ReactComponent };